import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Controls from "./Controls/Controls";
import Scene from "./Scene/Scene";

function Carousel({ majority, popinRef, setIsPopinOpen, setViewInPopin }) {
    // On initialise l'état du carousel
    const [ carouselIndex, setCarouselIndex ] = useState(0);

    // On initialise les vues
    const views = []

    // On met en place un écouteur de la majorité pour réinitialiser l'index du carousel
    useEffect(() => {
        setCarouselIndex(0);
    }, [majority]);

    // Et on peuple le tableau en fonction de la majorité des résultats
    if(majority === 'intime') {
        views.push({
            id: 1,
            label: 'Plus sur le tuner',
            position: { x: -3.07, y: 0.59, z: 2.28 },
            rotation: { x: 0.12, y: -0.94, z: 0.10 },
            orbit: { x: 0.25, y: 0.88, z: -0.11 }
        },
        {
            id: 2,
            label: 'Plus sur le volume',
            position: { x: -1.40, y: 2.42, z: -1.61 },
            rotation: { x: -2.26, y: -0.58, z: -2.55 },
            orbit: { x: 0.13, y: 0.60, z: -0.13 }
        },
        {
            id: 3,
            label: 'Plus sur la tache',
            position: { x: -1.41, y: 1.87, z: 1.35 },
            rotation: { x: -0.71, y: -0.73, z: -0.52 },
            orbit: { x: 0.19, y: 0.71, z: -0.00 }
        });
    } else if(majority === 'politique') {
        views.push({
            id: 4,
            label: 'Plus sur le choix des ondes',
            position: { x: -1.45, y: 2.77, z: -0.03 },
            rotation: { x: -1.57, y: -0.74, z: -1.57 },
            orbit: { x: 0.26, y: 0.90, z: -0.03 }
        },
        {
            id: 5,
            label: 'Plus sur le cadran des fréquences',
            position: { x: -2.26, y: 1.07, z: 0.40 },
            rotation: { x: -1.62, y: -1.47, z: -1.62 },
            orbit: { x: 0.25, y: 0.82, z: 0.41 }
        },
        {
            id: 6,
            label: "Plus sur l'éraflure",
            position: { x: -0.69, y: -0.24, z: -1.54 },
            rotation: { x: 2.61, y: -0.46, z: 2.88 },
            orbit: { x: 0.13, y: 0.60, z: -0.13 }
        });
    } else if(majority === 'festive') {
        views.push({
            id: 7,
            label: "Plus sur l'anse de transport",
            position: { x: -2.15, y: 2.51, z: -2.66 },
            rotation: { x: -2.54, y: -0.63, z: -2.75 },
            orbit: { x: 0.12, y: 0.74, z: -0.10 }
        },
        {
            id: 8,
            label: 'Plus sur le haut parleur',
            position: { x: -2.86, y: 0.83, z: -0.38 },
            rotation: { x: -2.03, y: -1.53, z: -2.03 },
            orbit: { x: 0.15, y: 0.72, z: -0.33 }
        },
        {
            id: 9,
            label: 'Plus sur le revêtement',
            position: { x: -0.69, y: 1.01, z: -1.75 },
            rotation: { x: -2.94, y: -0.53, z: -3.04 },
            orbit: { x: 0.15, y: 0.72, z: -0.33 }
        });
    }

    return (
        <div className="desktop-col-start--4 desktop-col-end--12 mobile-col-start--2 mobile-col-end--6 carousel carousel__container ">
            <Scene views={views} index={carouselIndex} isPerfVisible={false} />
            <Controls
                views={views}
                index={carouselIndex}
                setIndex={setCarouselIndex}
                popinRef={popinRef}
                setIsPopinOpen={setIsPopinOpen}
                setViewInPopin={setViewInPopin} />
        </div>
    )
}

Carousel.propTypes = {
    majority: PropTypes.string.isRequired,
    popinRef: PropTypes.object.isRequired,
    setIsPopinOpen: PropTypes.func.isRequired,
    setViewInPopin: PropTypes.func.isRequired
}

export default Carousel;
